/** Immutable View: a user the caller can filter the costs by, with the facilities in the caller's scope. */
class AiCostUserOptionView {
	readonly id: number;
	readonly label: string;
	readonly isActive: boolean;
	readonly facilityIds: readonly number[];

	constructor(payload: {
		readonly id: number;
		readonly label: string;
		readonly isActive: boolean;
		readonly facilities: readonly { readonly id: number }[];
	}) {
		this.id = payload.id;
		this.label = payload.label;
		this.isActive = payload.isActive;
		this.facilityIds = payload.facilities.map((facility) => facility.id);

		Object.freeze(this);
	}
}

export default AiCostUserOptionView;
